<template>
    <q-card flat class="c-ToolPanel_1 q-mx-auto w-100 q-pa-none" style="width: 100%; display: flex; flex-direction: column; min-width: 750px; max-width: 750px;" v-if="isvisible">
        <q-card flat class="q-mx-auto w-100" style="overflow: auto; width: 100%; display: flex; flex-direction: column; flex-basis: 0; flex-grow: 1; background-color: white;">
            <div style="padding: 8px 24px 16px;">
                <q-item-section class="text-h6 q-mb-lg q-mt-sm">
                    {{ Translate('Chart Settings') }}
                </q-item-section>

                <div>
                    <div class="q-px-sm q-pt-xs q-pb-none q-mt-sm consistentText" style="border-bottom: 2px solid var(--v-lightGreyBorder-base);">
                        {{ Translate('GENERAL') }}
                    </div>
                    <q-card-section class="q-mt-sm consistentText">
                        {{ Translate('Applies to all series.') }}
                    </q-card-section>

                    <q-card-section>
                        <q-input v-model="custom_chart_options.title.text" class="q-mb-sm"
                                    @update:model-value="updateChart" outlined dense hide-bottom-space :label="Translate('Title')"></q-input>

                        <q-input v-model="custom_chart_options.subtitle.text" class="q-mb-sm"
                                    @update:model-value="updateChart" outlined dense hide-bottom-space :label="Translate('Sub-Title')"></q-input>

                        <q-input :style="{ visibility: all_series.some(a => a.type == 'bar') ? 'visible' : 'hidden' }" class="q-mb-sm"
                                    type="number"
                                    v-model="cornerRadius"
                                    @change="updateChart"
                                    outlined
                                    dense
                                    :label="Translate('Corner Radius')"
                                    hide-bottom-space></q-input>

                        <q-input type="number"
                                    v-model="maxValues" :rules="maxValuesRules"
                                    outlined
                                    dense
                                    hide-hint
                                    :label="Translate('Maximum Data Points')"
                                    :hint="Translate('Constrains the results of the query to this number of rows (default 100, 1-5000 allowed)')"
                                    ></q-input>

                        <q-btn-group class="q-mr-md q-mt-sm" unelevated>
                            <q-btn v-for="btn in generalTypeToggleButtons" :key="btn.value"
                                :color="general_type === btn.value ? 'grey-3' : 'white'"
                                @click="general_type = btn.value">
                                <q-icon :name="btn.icon" style="color: var(--v-secondaryText-base);"/>
                                <q-tooltip>{{ Translate(btn.title) }}</q-tooltip>
                            </q-btn>
                        </q-btn-group>

                        <q-btn-group v-if="[0,1,7].includes(general_type)" class="q-mr-md q-mt-sm" unelevated>
                            <q-btn :color="general_direction === 0 ? 'grey-3' : 'white'" @click="general_direction = 0">
                                <q-icon name="mdi-chart-bar" style="color: var(--v-secondaryText-base);"/>
                                <q-tooltip>{{Translate("Vertical")}}</q-tooltip>
                            </q-btn>
                            <q-btn :color="general_direction === 1 ? 'grey-3' : 'white'" @click="general_direction = 1">
                                <q-icon name="mdi-chart-bar" class="mdi-rotate-90" style="color: var(--v-secondaryText-base);"/>
                                <q-tooltip>{{Translate("Horizontal")}}</q-tooltip>
                            </q-btn>
                        </q-btn-group>

                        <q-btn-group v-if="[1,4].includes(general_type)" class="q-mr-md q-mt-sm" unelevated>
                            <q-btn :color="general_percent === 0 ? 'grey-3' : 'white'" @click="general_percent = 0">
                                <q-icon name="mdi-format-align-left" class="mdi-rotate-270" style="color: var(--v-secondaryText-base);"/>
                                <q-tooltip>{{Translate("Standard")}}</q-tooltip>
                            </q-btn>
                            <q-btn :color="general_percent === 1 ? 'grey-3' : 'white'" @click="general_percent = 1">
                                <q-icon name="mdi-format-align-justify" class="mdi-rotate-270" style="color: var(--v-secondaryText-base);"/>
                                <q-tooltip>{{Translate("Normalized to 100")}}</q-tooltip>
                            </q-btn>
                        </q-btn-group>

                    </q-card-section>
                </div>
                <div>
                    <div class="q-px-sm q-pt-xs q-pb-none q-mt-sm consistentText" style="border-bottom: 2px solid var(--v-lightGreyBorder-base);">
                        {{ Translate('SPECIFIC') }}
                    </div>
                    <q-card-section class="q-mt-sm consistentText">
                        {{ Translate('Series specific settings. For unique chart types per series, select the mixed chart above.') }}
                    </q-card-section>

                    <q-card-section>
                        <div class="c-BasicTab">
                        <q-tabs v-model="active_tab" class="chart-tabs" align="left" indicator-color="transparent" :breakpoint="0" style="color: var(--v-secondaryText-base);">
                            <q-tab name="series" :label="Translate('Series')"></q-tab>
                            <q-tab name="axes" :label="Translate('Axes')"></q-tab>
                            <q-tab name="legend" :label="Translate('Legend')"></q-tab>
                        </q-tabs>
                        </div>
                        <q-tab-panels v-model="active_tab">
                            <q-tab-panel name="series" class="chart-tab-panel">
                                <q-list v-if="!isPivotting" class="chart-expansion-list">
                                    <q-expansion-item v-for="(item, i) in all_series" :key="i"
                                        group="chart-series"
                                        :default-opened="i===0"
                                        expand-icon="mdi-menu-down"
                                        :style="i < all_series.length - 1 ? 'border-bottom: 1px solid var(--v-lightGreyBorder-base);' : undefined">
                                        <template #header>
                                            <q-item-section>
                                                {{ Translate("Series") }} {{ i + 1 }}: {{ legendFormatter({ value: item.yKey }) }}
                                            </q-item-section>
                                        </template>

                                        <div class="q-mt-md">
                                            <q-btn-group v-show="general_type < 5" class="q-mr-md" unelevated>
                                                <q-btn :color="getChart(item) === 0 ? 'grey-3' : 'white'" :disabled="isCustomTypeDisabled" @click="setChartType(item, 'bar')">
                                                    <q-icon name="mdi-chart-bar" style="color: var(--v-secondaryText-base);"/>
                                                    <q-tooltip>{{Translate("Bar")}}</q-tooltip>
                                                </q-btn>
                                                    <q-btn :color="getChart(item) === 1 ? 'grey-3' : 'white'" :disabled="isCustomTypeDisabled" @click="setChartType(item, 'bar', true)">
                                                    <q-icon name="mdi-chart-bar-stacked" style="color: var(--v-secondaryText-base);"/>
                                                    <q-tooltip>{{Translate("Stacked Bar")}}</q-tooltip>
                                                </q-btn>
                                                    <q-btn v-if="general_direction === 0" :color="getChart(item) === 2 ? 'grey-3' : 'white'" :disabled="isCustomTypeDisabled" @click="setChartType(item, 'line')">
                                                    <q-icon name="mdi-chart-line" style="color: var(--v-secondaryText-base);"/>
                                                    <q-tooltip>{{Translate("Line")}}</q-tooltip>
                                                </q-btn>
                                                <q-btn v-if="general_direction === 0" :color="getChart(item) === 3 ? 'grey-3' : 'white'" :disabled="isCustomTypeDisabled" @click="setChartType(item, 'area')">
                                                    <q-icon name="mdi-chart-areaspline-variant" style="color: var(--v-secondaryText-base);"/>
                                                    <q-tooltip>{{Translate("Area")}}</q-tooltip>
                                                </q-btn>
                                                <q-btn v-if="general_direction === 0" :color="getChart(item) === 4 ? 'grey-3' : 'white'" :disabled="isCustomTypeDisabled" @click="setChartType(item, 'area', true)">
                                                    <q-icon name="mdi-chart-areaspline" style="color: var(--v-secondaryText-base);"/>
                                                    <q-tooltip>{{Translate("Stacked Area")}}</q-tooltip>
                                                </q-btn>
                                            </q-btn-group>

                                            <q-btn-group v-show="general_type < 5 && [1,4].includes(getChart(item))" unelevated>
                                                <q-btn :color="getNorm(item) === 0 ? 'grey-3' : 'white'" :disabled="isCustomTypeDisabled" @click="setNorm(item, 0)">
                                                    <q-icon name="mdi-format-align-left" class="mdi-rotate-270" style="color: var(--v-secondaryText-base);"/>
                                                    <q-tooltip>{{Translate("Standard")}}</q-tooltip>
                                                </q-btn>
                                                <q-btn :color="getNorm(item) === 1 ? 'grey-3' : 'white'" :disabled="isCustomTypeDisabled" @click="setNorm(item, 1)">
                                                    <q-icon name="mdi-format-align-justify" class="mdi-rotate-270" style="color: var(--v-secondaryText-base);"/>
                                                    <q-tooltip>{{Translate("Normalized to 100")}}</q-tooltip>
                                                </q-btn>
                                            </q-btn-group>

                                            <q-btn v-if="item.override_type || item.override_stacked" flat class="q-ml-lg q-mt-none" @click="revert(item)">
                                                <q-icon name="mdi-undo" style="color: var(--v-secondaryText-base);"/>
                                                <q-tooltip>{{Translate("Revert to Default")}}</q-tooltip>
                                            </q-btn>

                                            <q-input v-if="item.override_type ? (item.override_type == 'bar' || item.override_type == 'line') : [0,1,2].includes(general_type)"
                                                        v-model="item.override_title"
                                                        @update:model-value="updateChart"
                                                        outlined
                                                        dense
                                                        hide-hint
                                                        class="q-mt-md"
                                                        :hint="Translate('Customizes the series name as seen in the legend')"
                                                        :label="Translate('Series Name Override')"></q-input>

                                            <q-select v-if="item.override_stacked || generalTypes[general_type].stacked"
                                                    :model-value="item.override_group || item.stackGroup"
                                                    @update:model-value="(value) => setStackGroup(item, value)"
                                                    :options="stackGroupItems"
                                                    outlined
                                                    dense
                                                    hide-bottom-space
                                                    class="q-mt-sm"
                                                    :label="Translate('Group')"></q-select>

                                            <div v-if="item.override_type == 'line' || generalTypes[general_type].type == 'line' || item.override_type == 'area' || generalTypes[general_type].type == 'area'"
                                                class="q-mt-sm"
                                                style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 8px;">
                                                <q-checkbox v-model="item.marker_enabled"
                                                            @update:model-value="updateChart"
                                                            :label="Translate('Show Marker')"
                                                            dense
                                                            hide-bottom-space></q-checkbox>

                                                <q-checkbox v-model="item.label_enabled"
                                                            @update:model-value="updateChart"
                                                            :label="Translate('Show Labels')"
                                                            dense
                                                            hide-bottom-space></q-checkbox>

                                                <q-select v-if="item.marker_enabled"
                                                        :options="[
                                                            { label: Translate('circle'), value: 'circle' },
                                                            { label: Translate('cross'), value: 'cross' },
                                                            { label: Translate('diamond'), value: 'diamond' },
                                                            { label: Translate('heart'), value: 'heart' },
                                                            { label: Translate('plus'), value: 'plus' },
                                                            { label: Translate('pin'), value: 'pin' },
                                                            { label: Translate('square'), value: 'square' },
                                                            { label: Translate('star'), value: 'star' },
                                                            { label: Translate('triangle'), value: 'triangle' }
                                                        ]"
                                                        emit-value
                                                        map-options
                                                        v-model="item.marker_shape"
                                                        @update:model-value="updateChart"
                                                        outlined
                                                        dense
                                                        hide-bottom-space
                                                        :label="Translate('Marker Shape')"></q-select>

                                                <q-input v-if="item.marker_enabled"
                                                            v-model="item.marker_size"
                                                            @update:model-value="updateChart"
                                                            outlined
                                                            dense
                                                            hide-bottom-space
                                                            :label="Translate('Marker Size')"
                                                            type="number"></q-input>

                                                <q-input v-model="item.line_width"
                                                            @update:model-value="updateChart"
                                                            outlined
                                                            dense
                                                            hide-bottom-space
                                                            :label="Translate('Line Width')"
                                                            type="number"></q-input>
                                            </div>

                                            <q-select :model-value="getItemAxis(item)" @update:model-value="(value) => setItemAxis(item, value)"
                                                    :options="chartOptionsLocal.axes.filter(a => a.keys).concat(extraAxes).map(a => a.title.text)"
                                                    outlined
                                                    dense
                                                    hide-bottom-space
                                                    class="q-mt-sm"
                                                    :label="Translate('Axis')">

                                                <template v-slot:after>
                                                    <q-btn flat dense round size="sm" @click="addItemAxis(item)">
                                                        <q-icon name="mdi-plus" color="primary" />
                                                        <q-tooltip>{{Translate('Add')}}</q-tooltip>
                                                    </q-btn>
                                                </template>
                                            </q-select>
                                            
                                            <div v-if="item.type !== 'pie' && item.type !== 'donut'" class="q-mt-sm">
                                                {{Translate("Color:")}}
                                                <q-btn-dropdown 
                                                    outline 
                                                    dense 
                                                    class="q-ml-md"
                                                    v-model="item.showColorDropdown"
                                                >
                                                    <template #label>
                                                        <span class="rounded-borders" style="display:inline-block;width:22px;height:22px;border:1px solid rgba(0,0,0,.12);" :style="{ backgroundColor: item.color || '#000000' }" />
                                                    </template>
                                                    <q-color 
                                                        flat
                                                        :model-value="item.color || '#000000'"
                                                        default-view="palette"
                                                        format-model="hex"
                                                        no-header
                                                        no-footer
                                                        @update:model-value="(hex) => { onColorPickerUpdate(hex, item); item.showColorDropdown = false }"
                                                    ></q-color>
                                                </q-btn-dropdown>
                                            </div>
                               
                                        </div>
                                    </q-expansion-item>
                                </q-list>
                                <q-card-section v-else>
                                    {{ Translate('Series are automatic when pivotting.') }}
                                </q-card-section>

                                <pre v-if="show_debug" style="max-height: 400px; overflow: auto; font-size: small;">
                                {{ seriesJSON }}
                                </pre>
                            </q-tab-panel>

                            <q-tab-panel name="axes" class="chart-tab-panel">
                                <q-list class="chart-expansion-list">
                                    <q-expansion-item v-for="(item, i) in chartOptionsLocal.axes.concat(extraAxes)" :key="i"
                                        group="chart-axes"
                                        :default-opened="i===0"
                                        expand-icon="mdi-menu-down"
                                        :style="i < chartOptionsLocal.axes.concat(extraAxes).length - 1 ? 'border-bottom: 1px solid var(--v-lightGreyBorder-base);' : undefined">
                                        <template #header>
                                            <q-item-section avatar>
                                                <q-icon style="flex: none" :name="(item.position == 'bottom' || item.position == 'top') ? 'mdi-alpha-x-box-outline' : 'mdi-alpha-y-box-outline'" />
                                            </q-item-section>
                                            <q-item-section>
                                                {{ Translate(item.title.text) }}
                                            </q-item-section>
                                            <q-item-section side v-if="i >= chartOptionsLocal.axes.length">
                                                <q-btn flat dense round size="sm" icon="mdi-close-circle"
                                                    @click.stop="removeExtraAxis(i - chartOptionsLocal.axes.length)">
                                                </q-btn>
                                            </q-item-section>
                                        </template>

                                        <div class="q-mt-md">
                                            <q-input :label="Translate('Title')" v-model="item.title.text" outlined dense hide-bottom-space @update:model-value="updateChart"></q-input>
                                            <q-select @update:model-value="updateChart"
                                                    class="q-mt-md"
                                                    :label="Translate('Axis Type')"
                                                    :options="[
                                                        { label: Translate('time'), value: 'time' },
                                                        { label: Translate('ordinal-time'), value: 'ordinal-time' },
                                                        { label: Translate('category'), value: 'category' },
                                                        { label: Translate('number'), value: 'number' },
                                                        { label: Translate('log'), value: 'log' }
                                                    ]"
                                                    emit-value
                                                    map-options
                                                    v-model="item.type"
                                                    outlined
                                                    dense
                                                    hide-bottom-space></q-select>

                                            <q-card-actions class="q-pl-none q-pr-none">
                                                {{ Translate('Position:') }}
                                                
                                                <div class="q-ml-sm row" v-if="item.position == 'bottom' || item.position == 'top'">
                                                    <q-radio v-model="item.position" val="top" :label="Translate('Top')" @update:model-value="updateChart"></q-radio>
                                                    <q-radio v-model="item.position" val="bottom" :label="Translate('Bottom')" @update:model-value="updateChart"></q-radio>
                                                </div>

                                                <div class="q-ml-sm row" v-if="item.position == 'left' || item.position == 'right'">
                                                    <q-radio v-model="item.position" val="left" :label="Translate('Left')" @update:model-value="updateChart"></q-radio>
                                                    <q-radio v-model="item.position" val="right" :label="Translate('Right')" @update:model-value="updateChart"></q-radio>
                                                </div>
                                                
                                                <!--Color: <q-menu anchor="bottom left" self="top left" offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <q-btn small v-bind="attrs" v-on="on" class="q-ml-md">
                                                            <q-btn x-small flat disabled :style="{ backgroundColor: item.label.color }"></q-btn>
                                                            <q-icon>mdi-menu-down</q-icon>
                                                        </q-btn>
                                                    </template>

                                                    <q-color flat
                                                        :model-value="item.label.color || '#000000'"
                                                        default-view="palette"
                                                        format-model="hex"
                                                        no-header
                                                        no-footer
                                                        :palette="colorPalette"
                                                        @update:model-value="(hex) => { item.label.color = hex; updateChart(); }"></q-color>
                                                </q-menu>-->
                                            </q-card-actions>

                                            <q-card-actions class="q-pl-none q-pr-none" style="gap: 16px;">
                                                <q-input v-if="item.type == 'number'"
                                                            :label="Translate('Tick Interval')"
                                                            class="q-mt-none q-pt-none"
                                                            outlined dense
                                                            hide-bottom-space
                                                            type="number"
                                                            :value="getTickInterval(item)"
                                                            @change="(v) => setTickInterval(item, v)"></q-input>

                                                <q-input :label="Translate('Tick Min Spacing')"
                                                            outlined dense
                                                            hide-bottom-space
                                                            type="number"
                                                            v-model.number="item.tick.minSpacing"
                                                            @change="updateChart"></q-input>

                                                <q-input :label="Translate('Tick Max Spacing')"
                                                            outlined dense
                                                            hide-bottom-space
                                                            type="number"
                                                            v-model.number="item.tick.maxSpacing"
                                                            @change="updateChart"></q-input>

                                            </q-card-actions>

                                            <div class="q-py-xs q-px-none" v-if="item.keys">
                                                {{ Translate('Series:') }} <q-chip v-for="(chip,j) in getAxisSeries(item.keys)" :key="j" class="q-ma-sm">{{ chip }}</q-chip>
                                                <!--{{ getAxisSeries(item.keys) }}-->
                                            </div>
                                            
                                            <pre v-if="show_debug" style="max-height: 400px; overflow: auto; font-size: small;">
                                            {{ axesJSON }}
                                            </pre>
                                        </div>
                                    </q-expansion-item>
                                </q-list>
                            </q-tab-panel>

                            <q-tab-panel name="legend" class="legendTabPanel">
                                <q-card flat>
                                    <q-card-section>
                                        <q-select outlined dense hide-bottom-space
                                                class="q-mt-sm"
                                                :label="Translate('Position')"
                                                v-model="legend_position"
                                                :options="legend_positions"
                                                option-label="text"
                                                option-value="value"
                                                emit-value
                                                map-options></q-select>

                                        <q-checkbox v-if="isPivotting" dense hide-bottom-space :label="Translate('Suppress Metric Titles Suffix')" v-model="suppress_metric_suffix"></q-checkbox>
                                        <!--<q-checkbox dense hide-bottom-space label="Show Series Stroke" :disabled="disable_show_series_stroke" v-model="show_series_stroke"></q-checkbox>-->
                                    </q-card-section>
                                </q-card>
                            </q-tab-panel>
                        </q-tab-panels>

                        <q-icon v-if="false" name="mdi-bug" size="sm" :title="Translate('Toggle Debug')" @click="show_debug=!show_debug" />
                    </q-card-section>
                </div>
            </div>
        </q-card>
    </q-card>
</template>

<script>
    /* eslint-disable */

    import common from './common.js';
    import methods from '@/Shared/methods';
    import _ from 'lodash';

    export default {
        props: {
            column_list: {
                type: Array,
                required: false
            },
            settings: null,
            isvisible: null,
            initial_settings: null,
            chartOptions: null,
            pivot_columns: null,
            legendFormatter: null,
            notifychange: null,
            notifyrefresh: null,
            updateserialization: null,
        },
        data: function () {
            return {
                active_tab: 'series',
                active_series_tab: 0,
                active_axes_tab: 0,
                show_debug: false,
                general_type: 0,
                general_direction: 0,
                general_percent: 0,
                maxValues: 100,

                maxValuesRules: [
                    value => (value > 0 && value <= 5000) || this.Translate('Between 1-5000 only')
                ],

                chartOptionsLocal: null,
                chartTypeSelection: 0,
                chartTypeList: [
                    { id: 0, fn: 'chart_bar_vert.png', name: 'Vertical Bar', settings: { type: 'bar' } },
                    { id: 1, fn: 'chart_bar_horz.png', name: 'Horizontal Bar', settings: { type: 'bar', direction: 'horizontal' } },
                    { id: 2, fn: 'chart_bar_vert_stacked.png', name: 'Vertical Bar Stacked', settings: { type: 'bar', stacked: true } },
                    { id: 3, fn: 'chart_bar_horz_stacked.png', name: 'Horizontal Bar Stacked', settings: { type: 'bar', direction: 'horizontal', stacked: true } },
                    { id: 4, fn: 'chart_bar_vert_stacked_100.png', name: 'Vertical Bar Stacked 100%', settings: { type: 'bar', stacked: true, normalizedTo: 100 } },
                    { id: 5, fn: 'chart_bar_horz_stacked_100.png', name: 'Horizontal Bar Stacked 100%', settings: { type: 'bar', direction: 'horizontal', stacked: true, normalizedTo: 100 } },
                    { id: 6, fn: 'chart_line.png', name: 'Line', settings: { type: 'line' } },
                    { id: 7, fn: 'chart_area.png', name: 'Area', settings: { type: 'area' } },
                    { id: 8, fn: 'chart_area_stacked.png', name: 'Area Stacked', settings: { type: 'area', stacked: true } },
                    { id: 9, fn: 'chart_pie.png', name: 'Pie', settings: { type: 'pie' } },
                    { id: 10, fn: 'chart_donut.png', name: 'Donut', settings: { type: 'donut' } },
                ],

                legend_positions: [],
                legend_position: 'bottom',
                suppress_metric_suffix: false,
                show_series_stroke: false,
                disable_show_series_stroke: false,

                chartSeries: [],
                chartAxes: [],
                extraAxes: [],

                pivot_series: [],

                custom_chart_options: {
                    title: { text: '' },
                    subtitle: { text: '' },
                 },

                cornerRadius: 0,

                generalTypes: [
                    { type: 'bar' },
                    { type: 'bar', stacked: true },
                    { type: 'line' },
                    { type: 'area' },
                    { type: 'area', stacked: true },
                    { type: 'pie' },
                    { type: 'donut' },
                    { type: '' },
                ],
                customTypes: [
                    { type: 'bar' },
                    { type: 'bar', stacked: true },
                    { type: 'line' },
                    { type: 'area' },
                    { type: 'area', stacked: true },
                ],

                color_swatches: common.swatches,
                //[
                //    ['#FF0000', '#AA0000', '#550000'],
                //    ['#FFFF00', '#AAAA00', '#555500'],
                //    ['#00FF00', '#00AA00', '#005500'],
                //    ['#00FFFF', '#00AAAA', '#005555'],
                //    ['#0000FF', '#0000AA', '#000055'],
                //],
            }
        },
        watch: {
            general_percent: function (newv) {
                this.updateChart();
            },
            general_direction: function (newv) {
                this.updateChart();
            },
            general_type: function(newv) {
                this.updateChart();
            },
            chartOptions: function(newv) {
                console.log('received chartOptions:');
                console.log(JSON.stringify(newv.series, null, 3));

                // Merge updated options into local copy - series first:
                const updated_series = [];
                for(let i=0; i<newv.series.length; i++) {
                    const s = newv.series[i];
                    const f = this.chartOptionsLocal.series.find(a => a.yKey == s.yKey);

                    if (f) {
                        const new_s = { ...s, ...f, xKey: s.xKey };

                        updated_series.push(new_s);
                    }
                    else 
                        updated_series.push(s);
                }
                console.log('updated chartOptions:');
                console.log(JSON.stringify(updated_series,null,3));

                const updated_axes = [];
                // Two freshly generated axes very often share a title (two metrics both defaulting
                // to "Count"), so remember which local axis each one has claimed. Without this they
                // both re-match the first one found and its key list grows on every refresh.
                const matched_local_axes = new Set();
                for (let i = 0; i < newv.axes.length; i++) {
                    const x = newv.axes[i];
                    const fi = this.chartOptionsLocal.axes.findIndex((a, ai) => !matched_local_axes.has(ai) && a.title.text == x.title.text);
                    const f = fi >= 0 ? this.chartOptionsLocal.axes[fi] : undefined;

                    if (f) {
                        matched_local_axes.add(fi);
                        const new_a = { ..._.cloneDeep(x), ...f, ...(x.keys || f.keys ? { keys: [...new Set([...(x.keys || []), ...(f.keys || [])])] } : {}) };

                        if (x.keys)
                            for (let j = 0; j < x.keys.length; j++) {
                                // Ensure all the keys in the received axis are contained elsewhere, otherwise, add them
                                if (!this.chartOptionsLocal.axes.concat(this.extraAxes).some(a => !a.keys || (a.keys && a.keys.includes(x.keys[j]))))
                                    if (!new_a.keys.includes(x.keys[j]))
                                        new_a.keys.push(x.keys[j]);
                            }

                        updated_axes.push(new_a);
                    }
                    else
                        updated_axes.push(x);
                }

                // An axis split off by hand has no counterpart in the generated set, so carry it
                // over instead of losing it on the next refresh.
                for (let ai = 0; ai < this.chartOptionsLocal.axes.length; ai++)
                    if (!matched_local_axes.has(ai))
                        updated_axes.push(this.chartOptionsLocal.axes[ai]);

                this.chartOptionsLocal.series = updated_series;
                this.chartOptionsLocal.axes = updated_axes;
                this.updateChart(true);
            },
            //pivot_columns: function(newv) {
            //    this.generatePivotSeries(newv);
            //},
            cornerRadius: function(newv) {
                this.updateChart();
            },
            maxValues: function(newv) {
                if (newv > 0 && newv <= 5000)
                    this.notifychange(this.chartSeries, this.chartAxes, this.generalTypes[this.general_type], this.custom_chart_options, null, newv, true);
            },
            legend_position: function(newv) {
                this.updateChart(true);
            },
            suppress_metric_suffix: function (newv) {
                this.updateChart(true);
            },
            show_series_stroke: function (newv) {
                this.updateChart(true);
            },
        },
        created() {
            if (this.initial_settings && this.initial_settings.series) {
                this.chartOptionsLocal = {
                    series: this.initial_settings.series,
                    axes: this.initial_settings.axes,
                };
                this.custom_chart_options = this.initial_settings.options;
                this.legend_position = this.initial_settings.legend?.position || 'bottom';
                this.maxValues = this.initial_settings.maxValues;
                
                this.general_type = this.generalTypes.findIndex(a =>
                    a.type == this.initial_settings.typeSettings.type &&
                    a.stacked == this.initial_settings.typeSettings.stacked
                );

                if (this.initial_settings.typeSettings.direction)
                    this.general_direction = ['vertical', 'horizontal'].indexOf(this.initial_settings.typeSettings.direction);

                // Walk through each series and identify those that have override settings
                for (let s of this.chartOptionsLocal.series) {
                    if (s.type != this.initial_settings.typeSettings.type || s.stacked != this.initial_settings.typeSettings.stacked) {
                        s.override_type = s.type;
                        s.override_stacked = s.stacked;
                    }
                    if (s.normalizedTo == 100)
                        s.override_norm = '1';
                    if (s.title)
                        s.override_title = s.title;
                    else if (s.legendItemName)
                        s.override_title = s.legendItemName;

                    if (s.marker && s.marker.enabled) {
                        if (s.marker.shape)
                            s.marker_shape = s.marker.shape;
                        if (s.marker.size)
                            s.marker_size = s.marker.size.toString();
                    }

                    if (s.label && s.label.enabled)
                        s.label_enabled = s.label.enabled;

                    if (s.strokeWidth)
                        s.line_width = s.strokeWidth.toString();

                    if (s.stroke)
                        s.color = s.stroke;

                    if(s.fill)
                        s.color = s.fill;
                }
            }
            else
                this.chartOptionsLocal = {
                    series: [ ...this.chartOptions.series ],
                    axes: [ ...this.chartOptions.axes.map(x => ({ ...x })) ],
                };

            this.legend_positions = [
                { text: this.Translate('Left'), value: 'left' },
                { text: this.Translate('Top'), value: 'top' },
                { text: this.Translate('Right'), value: 'right' },
                { text: this.Translate('Bottom'), value: 'bottom' },
            ];
        },
        mounted() {
        },
        computed: {
            generalTypeToggleButtons() {
                return [
                    { value: 0, icon: 'mdi-chart-bar', title: this.Translate('Bar') },
                    { value: 1, icon: 'mdi-chart-bar-stacked', title: this.Translate('Stacked Bar') },
                    { value: 2, icon: 'mdi-chart-line', title: this.Translate('Line') },
                    { value: 3, icon: 'mdi-chart-areaspline-variant', title: this.Translate('Area') },
                    { value: 4, icon: 'mdi-chart-areaspline', title: this.Translate('Stacked Area') },
                    { value: 5, icon: 'mdi-chart-pie', title: this.Translate('Pie') },
                    { value: 6, icon: 'mdi-chart-donut', title: this.Translate('Donut') },
                ];
            },
            all_series: function() {
                return this.chartOptionsLocal.series; // .concat(this.pivot_series);
            },
            chartTypes: function() {
                return this.chartTypeList.map(a => a.settings);
            },
            seriesJSON: function() {
                return JSON.stringify(this.chartSeries,null,3);
            },
            axesJSON: function () {
                return JSON.stringify(this.chartOptionsLocal.axes, null, 3);
            },
            stackGroupItems: function() {
                return [
                    ...new Set(this.chartOptionsLocal.series.filter(a => a.stackGroup).map(a => a.stackGroup)),
                    'customGroup1',
                    'customGroup2',
                    'customGroup3',
                    'customGroup4',
                    'customGroup5',
                    'customGroup6',
                ];
            },
            isCustomTypeDisabled: function() {
                return this.chartOptionsLocal.series.length == 1;
            },
            isPivotting: function() {
                return this.pivot_columns && this.pivot_columns.length > 0;
            },
            colorPalette: function () {
                return this.color_swatches.flat();
            },
        },
        methods: {
            ...methods,
            updateChart(refreshOnly) {
                //console.log('chartOptionsLocal.series:');
                //console.log(JSON.stringify(this.chartOptionsLocal.series,null,3));

                const chart = this.generalTypes[this.general_type];
                const series = [];
                this.disable_show_series_stroke = false;
                for (let s of this.all_series) {
                    const new_s = {
                        type: s.override_type || chart.type,
                        xKey: s.xKey,
                        yKey: s.yKey,
                    };
                    if (new_s.type == 'bar') {
                        new_s.direction = ['vertical', 'horizontal'][this.general_direction];

                        if (this.cornerRadius)
                            new_s.cornerRadius = parseInt(this.cornerRadius);
                    }
                    if (s.override_stacked === true)
                        new_s.stacked = true;
                    else if (s.override_stacked === false)
                        new_s.stacked = false;
                    else if (chart.stacked)
                        new_s.stacked = chart.stacked;

                    if (new_s.stacked && (s.override_group || s.stackGroup))
                        new_s.stackGroup = s.override_group || s.stackGroup;

                    if (s.override_norm) {
                        // If overridden, honor the either set or unset state (if not set, leave out)
                        if (s.override_norm == '1')
                            new_s.normalizedTo = 100;
                    }
                    else if (this.general_percent)
                        // If not overridden, honor the general setting
                        new_s.normalizedTo = 100;

                    if (s.override_title)
                        switch (new_s.type){
                            case 'line': new_s.title = s.override_title; break;
                            case 'bar': new_s.legendItemName = s.override_title; break;
                        }

                    if (new_s.type == 'line' || new_s.type == 'area') {
                        if (s.marker_enabled)
                            new_s.marker = { enabled: true, shape: s.marker_shape || 'circle', size: parseInt(s.marker_size || '5') };
                        else {
                            new_s.marker = { enabled: false };
                            this.show_series_stroke = true;
                            this.disable_show_series_stroke = true;
                        }

                        if (s.label_enabled)
                            new_s.label = { enabled: true };

                        if (s.line_width && s.line_width != '0')
                            new_s.strokeWidth = parseInt(s.line_width);
                    }

                    if (s.color) {
                        switch (new_s.type){
                            case 'area':
                            case 'bar': new_s.fill = s.color; break;
                            case 'line': 
                            default: new_s.stroke = s.color; break;
                        }
                    }

                    series.push(new_s);
                }
                //console.log('updateChart series:');
                //console.log(JSON.stringify(series,null,3));

                this.chartSeries = series;

                const axes = [];
                for (let a of this.chartOptionsLocal.axes) {
                    const new_a = {
                        type: a.type,
                        position: a.position,
                        title: { text: a.title.text },
                        tick: a.tick,
                    };

                    if (a.keys)
                        new_a.keys = [ ...a.keys ];

                    if ('min' in a)
                        new_a.min = a.min;

                    if ('color' in a)
                        new_a.color = a.color;

                    axes.push(new_a);
                }
                for (let a of this.extraAxes) {
                    const new_a = {
                        type: a.type,
                        position: a.position,
                        title: a.title,
                        tick: a.tick,
                    };

                    if (a.keys)
                        new_a.keys = [ ...a.keys ];

                    if ('min' in a)
                        new_a.min = a.min;

                    if ('color' in a)
                        new_a.color = a.color;

                    axes.push(new_a);
                }

                // Go back over the series and handle any that have been moved to a different axes
                for (let s of this.all_series)
                    if (s.override_axis) {
                        let x_from = axes.find(a => a.keys && a.keys.some(k => k == s.yKey));
                        let x_goto = axes.find(a => a.keys && a.title.text == s.override_axis);

                        if (x_from && x_goto) {
                            const old_idx = x_from.keys.findIndex(a => a == s.yKey);
                            if (old_idx >= 0)
                                x_from.keys.splice(old_idx, 1);

                            x_goto.keys.push(s.yKey);
                        }
                    }


                //console.log('updateChart axes:');
                //console.log(JSON.stringify(axes, null, 3));

                this.chartAxes = axes;

                if (chart.type == 'bar')
                    chart.direction = ['vertical', 'horizontal'][this.general_direction];

                let legend = {
                    enabled: true,
                    position: this.legend_position,
                    suppress_metric_suffix: this.suppress_metric_suffix,
                    showSeriesStroke: this.show_series_stroke,
                };

                // Notify container of the customizations only used to save the report
                //this.updateserialization({
                //    series: this.chartOptionsLocal.series,
                //    axes: this.chartOptionsLocal.axes.concat(this.extraAxes),
                //    options: this.custom_chart_options,
                //    legend: legend,
                //    maxValues: this.maxValues,
                //    typeSettings: chart,
                //});

                if (refreshOnly)
                    this.notifyrefresh(series, axes, chart, this.custom_chart_options, legend);
                else
                    this.notifychange(series, axes, chart, this.custom_chart_options, legend, this.maxValues);
            },
            //generatePivotSeries() {
            //    if (!this.pivot_columns || this.chartOptionsLocal.series.length < 1) {
            //        console.log('pivot_series empty');
            //        this.pivot_series = [];
            //        return;
            //    }

            //    const chart = this.generalTypes[this.general_type];

            //    // Use the first normal series to detect the type, direction, xKey, etc.
            //    const s0 = this.chartOptionsLocal.series[0];
            //    const series = [];
            //    for (let i = 0; i < this.pivot_columns.length; i++) {
            //        const s = this.pivot_columns[i];

            //        // Preserve any customizations already done by reading the previous series value (if any)
            //        const old_s = this.pivot_series.find(a => a.yKey == s);
                    
            //        const new_s = {
            //            ...old_s,
            //            xKey: s0.xKey,
            //            yKey: s,
            //        };

            //        series.push(new_s);
            //    }

            //    console.log('pivot_series:');
            //    console.log(JSON.stringify(series, null, 3));

            //    this.pivot_series = series;
            //},
            setChart(item, idx) {
                const chart = this.customTypes[idx];
                const dirs = ['vertical', 'horizontal'];

                // If we have selected the same chart type as the general
                // type setting, then don't include an override_type, the
                // series type will remain sync'ed with the general type.
                if (idx == this.general_type) {
                    delete item.override_type;
                    delete item.override_stacked;
                }
                else {
                    // The override type will supercede the general type for
                    // this series. No changes to the general type will affect it.
                    item.override_type = chart.type;
                    item.override_stacked = chart.stacked;
                }
                console.log(`setChart(item:${item.type},idx:${idx})`);
                console.log(JSON.stringify(item,null,3));
                this.updateChart();
            },
            setChartType(item, type, stacked) {
                const chart = this.generalTypes[this.general_type];

                if (type == chart.type && stacked == chart.stacked) {
                    delete item.override_type;
                    delete item.override_stacked;
                }
                else
                {
                    item.override_type = type;
                    item.override_stacked = !!stacked;
                }

                console.log(`setChartType(item:${item.yKey},type:${type},stacked:${stacked})`);
                console.log(JSON.stringify(item, null, 3));
                this.updateChart();
            },
            getChart(item) {
                // Return the index in the button group that represents which
                // chart type is active for the current series (item). If item
                // has a override_type field, then we will return the index
                // based on that field. Otherwise, we will return the index
                // based on the regular type field, which is changed only
                // through changing the general_type button group.
                
                const chart = this.generalTypes[this.general_type];

                // Search for the matching index in the custom types array based on either
                // the overridden settings or the general settings. If not overridden, the
                // selection will stay synchronized with the general settings.
                const idx = this.customTypes.findIndex(a => {
                    let found = a.type == (item.override_type || chart.type);

                    if (['bar','area'].includes(item.override_type || chart.type)) {
                        if (item.override_stacked === true)
                            found = found && a.stacked;
                        else if (item.override_stacked === false)
                            found = found && !a.stacked;
                        else
                            found = found && a.stacked == chart.stacked;
                    }
                    else
                        found = found && !a.stacked;

                    return found;
                });

                //console.log(`getChart(item:${JSON.stringify(item)}); customTypes[${idx}]`);

                return idx;
            },
            setNorm(item, idx) {
                if (idx == this.general_percent)
                    delete item.override_norm;
                else
                    item.override_norm = `${idx}`; // '0' or '1' -- can't detect 0 easily, so store as strings

                this.updateChart();
            },
            getNorm(item) {
                if (item.override_norm)
                    return parseInt(item.override_norm);
                else
                    return item.normalizedTo ? 1 : 0;
            },
            setStackGroup(item, value) {
                if (value == item.stackGroup)
                    delete item.override_group;
                else
                    item.override_group = value;

                this.updateChart();
            },
            revert(item) {
                delete item.override_type;
                delete item.override_stacked;

                this.updateChart();
            },

            getImage(id){
                console.log(`getImage(id: ${id})`);

                const item = this.chartTypeList.find(a => a.id === id);
                
                if (item)
                    return item.fn;

                return '';
            },
            getTitle(id) {
                const item = this.chartTypeList.find(a => a.id === id);

                if (item)
                    return this.Translate(item.name);

                return '';
            },
            getIcon(item) {
                const chart = this.generalTypes[this.general_type];

                if (!item.override_type)
                    return 'mdi-checkbox-blank-outline'; // checkbox-blank-outline // mdi-chevron-down-box-outline

                switch (item.override_type || chart.type) {
                    case 'bar':
                        if (item.override_stacked || chart.stacked)
                            return 'mdi-chart-bar-stacked';
                        else
                            return 'mdi-chart-bar';

                    case 'line':
                        return 'mdi-chart-line';

                    case 'area':
                        if (item.override_stacked || chart.stacked)
                            return 'mdi-chart-areaspline';
                        else
                            return 'mdi-chart-areaspline-variant';

                    default:
                        return 'mdi-chart-box-outline';
                }
            },

            getItemAxis(item) {
                if (item.override_axis)
                    return item.override_axis;

                let x = this.chartOptionsLocal.axes.find(a => a.keys && a.keys.some(k => k == item.yKey));
                if (!x)
                    x = this.extraAxes.find(a => a.keys.some(k => k == item.yKey));

                if (x)
                    return x.title.text;

                return '';
            },
            addItemAxis(item) {
                let old_axis = this.chartOptionsLocal.axes.find(a => a.keys && a.keys.some(k => k == item.yKey));
                if (old_axis) {
                //    const old_idx = old_axis.keys.findIndex(a => a == item.yKey);
                //    if (old_idx >= 0)
                //        old_axis.keys.splice(old_idx, 1);
                }
                else {
                    old_axis = this.extraAxis.find(a => a.keys.some(k => k == item.yKey));
                    //if (old_axis) {
                    //    const old_idx = old_axis.keys.findIndex(a => a == item.yKey);
                    //    if (old_idx >= 0)
                    //        old_axis.keys.splice(old_idx, 1);
                    //}
                }

                if (!old_axis)
                    return;

                let position = old_axis.position;
                if (position == 'left') position = 'right'; else if (position == 'right') position = 'left';
                if (position == 'top') position = 'bottom'; else if (position == 'bottom') position = 'top';

                this.extraAxes.push({
                    type: old_axis.type,
                    position: position,
                    title: { text: `${old_axis.title.text}_2` },
                    label: { ...old_axis.label },
                    tick: {},
                    keys: [ item.yKey ],
                    min: old_axis.min,
                });

                item.override_axis = `${old_axis.title.text}_2`;

                this.updateChart();
            },
            setItemAxis(item, value) {
                // Rather than update the axes keys list to truly move the
                // series to another axes, we are going to just save a field
                // called 'override_axis' with the name of the target axes.
                // If the value that we are setting it to matches the pre-existing
                // axes name, then remove the override flag, it is just being
                // reverted.

                let x_from = this.chartOptionsLocal.axes.find(a => a.keys && a.keys.some(k => k == item.yKey));
                if (!x_from) x_from = this.extraAxes.find(a => a.keys.some(k => k == item.yKey));
                if (x_from) {
                    if (x_from.title.text == value)
                        delete item.override_axis;
                    else
                        item.override_axis = value;
                }

                //let x_from = this.chartOptionsLocal.axes.find(a => a.keys && a.keys.some(k => k == item.yKey));
                //let x_goto = this.chartOptionsLocal.axes.find(a => a.keys && a.title.flat == value);

                //if (!x_from) x_from = this.extraAxes.find(a => a.keys.some(k => k == item.yKey));
                //if (!x_goto) x_goto = this.extraAxes.find(a => a.title.flat == value);



                //if (x_from) {
                //    const old_idx = x_from.keys.findIndex(a => a == item.yKey);
                //    if (old_idx >= 0)
                //        x_from.keys.splice(old_idx, 1);
                //}

                //if (x_goto)
                //    x_goto.keys.push(item.yKey);

                this.updateChart();
            },
            removeExtraAxis(index) {
                this.extraAxes.splice(index, 1);
                this.updateChart();
            },
            getAxisSeries(keys) {
                return keys.map(a => this.legendFormatter({ value: a })); // .join(', ');
            },

            getTickInterval(item) {
                if (item.tick && item.tick.interval)
                    return item.tick.interval;
                else
                    return 0;
            },
            setTickInterval(item, v) {
                if (!item.tick)
                    item.tick = { };

                if (!v)
                    delete item.tick.interval;
                else
                    item.tick.interval = parseFloat(v);

                this.updateChart(true);
            },
            updateColor(hex, item) {
                //this is the default when you first click on the color picker and since it's not one of the swatches, 
                // we don't want to show it until they select a color.  need to updateChart again the first time we select a color
                // or else it won't reflect the selected change until you select a color a second time.  
                if(hex != "#FF0000") {
                    var colorObject = typeof item.color === 'object';
                    item.color = hex;
                    if(colorObject)
                        this.updateChart(true)
                }
            },
            onColorPickerUpdate(hex, item) {
                this.updateColor(hex, item);
                this.updateChart();
            }
        }
    }
</script>

<style scoped>
    .columns-three {
        column-count: 3;
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    p {
        font-size: 2em;
        text-align: center;
    }

    .metric_normal {

    }
    .metric_inuse {
        color: cornflowerblue;
    }
    .metric_usedup {
        color: silver;
    }
    
    .chart-tabs {
        border-bottom: none !important;
    }
    .chart-tabs :deep(.q-tabs__indicator) {
        display: none;
    }
    .chart-tab-panel {
        padding: 0;
    }
    .chart-expansion-list {
        padding: 0;
    }
    .chart-expansion-list :deep(.q-expansion-item__content) {
        padding: 0 24px 16px;
    }
    .chart-expansion-list :deep(.q-expansion-item__container > .q-item) {
        min-height: 64px;
        padding: 0 16px;
        color: var(--v-primaryText-base);
        font-size: 1rem;
    }
    .chart-expansion-list :deep(.q-expansion-item__container > .q-item > .q-item__section--side:last-of-type) {
        padding-right: 0;
    }
    .chart-expansion-list :deep(.q-expansion-item:first-child .q-expansion-item__container) {
        overflow: hidden;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .chart-expansion-list :deep(.q-expansion-item:first-child .q-expansion-item__container > .q-item) {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .chart-expansion-list :deep(.q-expansion-item--expanded > .q-expansion-item__container > .q-item),
    .chart-expansion-list :deep(.q-expansion-item > .q-expansion-item__container > .q-item:hover) {
        background-color: var(--v-gridHeader-base);
    }
    .chart-expansion-list :deep(.q-expansion-item > .q-expansion-item__container > .q-item > .q-focus-helper) {
        display: none;
    }
    .chart-expansion-list :deep(.q-expansion-item__toggle-icon) {
        color: var(--v-secondaryText-base);
    }
    .consistentText {
        color: var(--v-black-base) !important; 
        opacity: 0.8 !important; 
        font-size: 14px !important; 
        text-rendering: optimizelegibility !important; 
        letter-spacing:0.1 !important;
    }
    .legendTabPanel, .legendTabPanel .q-card__section {
        padding: 0;
    }
</style>